/** Days until a YYYY-MM-DD date from today (can be negative if expired) */
export function daysUntil(dateStr) {
  if (!dateStr) return Infinity;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${dateStr}T00:00:00`);
  return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
}

/**
 * Expiry badge tiers:
 *  RED    — expired or ≤ 7 days (blinking)
 *  YELLOW — ≤ 60 days
 *  GREEN  — > 60 days
 */
export function getExpiryStatus(dateStr) {
  const days = daysUntil(dateStr);

  if (days <= 7) {
    return {
      tier: 'critical',
      label: days < 0 ? 'Expired' : `${days}d left`,
      className: 'bg-red-500/15 text-red-700 ring-red-500/30',
      blink: true,
    };
  }

  if (days <= 60) {
    return {
      tier: 'warning',
      label: `${days}d left`,
      className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30',
      blink: false,
    };
  }

  return {
    tier: 'valid',
    label: 'Valid',
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
    blink: false,
  };
}

export function formatDate(dateStr) {
  return new Intl.DateTimeFormat('en-AE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(`${dateStr}T00:00:00`));
}
